import React from 'react';

import paymentPageStyles from './paymentPage.module.css';
import { withStyles } from '@material-ui/core/styles';

interface paymentDetailsCreditProps {
  due: string;
  items: number;
  totalPay: string;
  disabled: boolean;
  totalConvenience: string;
  textConvenienceFee: string;
  fwdInvoiceBalance: number;
  classes: any;
  type: string;
};

const styles = (theme: any) => ({
  green: {
    color: 'green'
  },
  red: {
    color: 'red'
  }
});

const paymentDetailsCredit = (props: paymentDetailsCreditProps) => {
  const balance =  props.fwdInvoiceBalance - Number(props.totalPay);
  const classColor = balance > 0 ? props.classes.green : props.classes.red;
  const totalCredit = props.type == 'gha' ? Number(props.fwdInvoiceBalance) - Number(props.totalConvenience) : props.fwdInvoiceBalance;
  return (

    <div className={ [paymentPageStyles.invoiceWrapper].join(' ') }>
      <div className={ [paymentPageStyles.invoiceItemsWrapper, props.disabled ? paymentPageStyles.disabledLabelColor : '' ].join(' ') }>

        <div className={ paymentPageStyles.itemText }>Credit Available:</div>

          <div className={ paymentPageStyles.invoicePrice }>

            <div>$</div> 
            <div>{ totalCredit }</div>

          </div>

      </div>
      <div className={ [paymentPageStyles.invoiceItemsWrapper, props.disabled ? paymentPageStyles.disabledLabelColor : '' ].join(' ') }>

        <div className={ paymentPageStyles.itemText }>Current amount due:</div>

        <div className={ paymentPageStyles.invoicePrice }>

          <div>$</div> 
          <div>{ props.due }</div>

        </div>

      </div>

      { props.type !== 'gha' && <div className={ [paymentPageStyles.invoiceItemsWrapper, props.disabled ? paymentPageStyles.disabledLabelColor : '' ].join(' ') }>

        <div className={ paymentPageStyles.itemText} >{ props.textConvenienceFee }</div> 

        <div className={ [paymentPageStyles.invoicePrice, paymentPageStyles.border].join(' ') }>

          <div>$</div> 
          <div>{ props.totalConvenience }</div>

        </div>

      </div>}

      { props.type !== 'gha' && <div className={ paymentPageStyles.invoiceItemsWrapper }>

        <div className={ paymentPageStyles.itemText } >New Credit Balance</div>

        <div className={ [paymentPageStyles.invoicePrice, classColor].join(" ") }>

          <div>$</div> 
          <div>{ balance }</div>

        </div>

      </div>}

    </div>
  );
};

export default withStyles(styles)(paymentDetailsCredit);
